import { useContext, useEffect, useState } from "react";
import Api from "./api/api";
import { AppContext } from "../App";
import jwt_decode from "jwt-decode";
import logo from "../images/logo.png";
import NumericPinPad from "./ui/NumericPinPad";

function PinLogin() {
	const { shops, setUser, setPermissions, shop, setShop } = useContext(AppContext);
	const [shopId, setShopId] = useState(() => {
		const storedShopId = localStorage.getItem("pos-shop-id") || "";
		const stored = shops.find((s) => s.id == storedShopId);
		return stored && stored.license_expired ? "" : storedShopId;
	});

	useEffect(() => {
		console.log("shopId set to", shopId);
		localStorage.setItem("pos-shop-id", shopId);
		if (shopId) {
			const selected = shops.find((s) => s.id == shopId);
			if (selected) setShop(selected);
		}
	}, [shopId]);

	const handleSubmit = async (pin) => {
		const login = await Api.pinLogin({ shop_id: shopId, pin: pin });
		if (login.success == 0) alert(login.error);
		else {
			const decoded = jwt_decode(login.token);
			localStorage.setItem("pos-user", login.token);
			const response = await Api.getProtected("/users/get/" + decoded.user_id + "/");
			if (response.success == 0) alert(response.error);
			else {
				setUser(response.data);
				setPermissions(response.data?.role?.pos_permissions || []);
			}
		}
	};

	return (
		<div className="login">
			<div className="content">
				<div className="login-logo">
					<img src={logo} />
				</div>
				<h2>YellGO POS</h2>
				<select
					name="shop_id"
					onChange={(e) => setShopId(e.target.value)}
					value={shopId}
					required
				>
					<option value=""></option>
					{shops.map((s, i) => (
						<option key={i} value={s.id} disabled={!!s.license_expired}>
							{s.name}
							{s.license_expired ? " (licenza scaduta)" : ""}
						</option>
					))}
				</select>
				<NumericPinPad onSubmit={(v) => handleSubmit(v)} showEuroSign={false} />
			</div>
		</div>
	);
}

export default PinLogin;
